<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="orderCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="回退"
            v-allow="'actCancelBill'"
            placement="top"
          >
            <i class="el-icon-refresh-left tool-btn" @click="cancel(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailDialog(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableColumns: tableColumns(),
      fullScreenLoading: false,
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 242
    },
    //单个回退订单
    cancel(row) {
      this.selectList = []
      this.selectList.push(row.orderCode)
      this.$confirm('确认要回退账单吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.updateStatement()
      })
    },
    //批量回退订单
    batchSumit() {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.table.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要处理的单据')
        return false
      }
      this.selectList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          this.selectList.push(row.orderCode)
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          this.selectList.push(row.orderCode)
        })
      }
      if (totCount > 20) {
        this.$message.warning('每次批量提交处理的单据数量，不能超过20张')
        return false
      }
      this.updateStatement()
    },
    updateStatement() {
      this.fullScreenLoading = true
      this.$api
        .financeCustomerUpdateStatusApi({ orderCodeList: this.selectList })
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          // 清除选中的记录
          this.$refs.table.clearCheckboxRow()
          this.$refs.table.clearCheckboxReserve()
          this.$emit('reload')
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    openOrderDetailDialog(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no },
      })
    },
  },
}
</script>
